// ABOUTME: Navigation component — thin orchestrator shell
// ABOUTME: Delegates desktop/mobile rendering and state to extracted sub-components and hooks
import { clx } from "@hm/fundamental"
import React from "react"

import { NavigationContext } from "./NavigationContext"
import { DesktopNav } from "./desktop-nav"
import { MobileNav } from "./mobile-nav"
import { MobileOverlay } from "./mobile-overlay"
import type { NavigationTabsProps } from "./types"
import { useNavigationState } from "./useNavigationState"

export type { NavigationSubrouteProps, NavigationTabsProps } from "./types"

interface BaseNavigationProps {
	children?: React.ReactNode
	className?: string
	"data-cy"?: string
}

interface NavigationProps extends BaseNavigationProps {
	navigationTabs?: never
	leftSideButtons?: React.ReactNode
	rightSideButtons?: React.ReactNode
	rightSideButtonsMobile?: React.ReactNode
}

interface NavigationPropsWithNavigation extends BaseNavigationProps {
	navigationTabs: NavigationTabsProps[]
	leftSideButtons?: React.ReactNode
	rightSideButtons?: React.ReactNode
	rightSideButtonsMobile?: React.ReactNode
}

export const Navigation: React.FC<
	NavigationProps | NavigationPropsWithNavigation
> = ({
	children,
	navigationTabs,
	leftSideButtons,
	rightSideButtons,
	rightSideButtonsMobile,
	className,
	"data-cy": testId,
}) => {
	const state = useNavigationState(navigationTabs)

	return (
		<NavigationContext.Provider value={state}>
			<div
				data-cy={testId}
				className={clx(
					"flex justify-between items-center min-h-64px px-24px md:px-48px bg-navigation_background text-foreground relative z-[9999]",
					className,
				)}
			>
				<DesktopNav
					navigationTabs={navigationTabs}
					leftSideButtons={leftSideButtons}
					rightSideButtons={rightSideButtons}
				>
					{children}
				</DesktopNav>

				<MobileNav
					navigationTabs={navigationTabs}
					rightSideButtonsMobile={rightSideButtonsMobile}
				>
					{children}
				</MobileNav>
			</div>

			{navigationTabs && state.isMenuOpened && <MobileOverlay />}
		</NavigationContext.Provider>
	)
}
